import { useQuery } from "@apollo/client";
import { useSnackbar } from "notistack";
import React from "react";
import { EmployeeList } from "../../components/Employee";
import EmployeeDialog from "../../components/Employee/EmployeeDialog";
import { DEFAULT_LIMIT } from "../../constants";
import { LIST_EMPLOYEES_FOR_LOCATION } from "../../graphql/queries";
import { ListEmployeesForLocationQuery } from "../../graphql/queries/listEmployeesForLocation";
import { ListEmployeesForLoctionQueryVariables } from "../../graphql/types";

interface Props {
  locationId: string;
}

const LocationEmployees: React.FC<Props> = ({ locationId }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [showDialog, setShowDialog] = React.useState<boolean>(false);
  const { data, loading, error, fetchMore } = useQuery<
    ListEmployeesForLocationQuery,
    ListEmployeesForLoctionQueryVariables
  >(LIST_EMPLOYEES_FOR_LOCATION, {
    variables: {
      locationId,
      limit: DEFAULT_LIMIT,
    },
    onError(error) {
      console.log(error);
      enqueueSnackbar(
        "Fehler beim laden der Testpersonendaten für den Standort",
        {
          variant: "error",
        }
      );
    },
  });

  const _handleCloseDialog = () => {
    setShowDialog(false);
  };
  const _openDialog = () => {
    setShowDialog(true);
  };
  const { listEmployees } = data || {};

  const { items, nextToken } = listEmployees || {};
  return (
    <>
      <EmployeeDialog
        locationId={locationId}
        open={showDialog}
        handleClose={_handleCloseDialog}
      />
      {!error && (
        <EmployeeList
          items={items || []}
          loading={loading}
          hasMore={!!nextToken}
          openDialog={_openDialog}
          loadMore={() => {
            if (nextToken) {
              fetchMore({
                variables: { locationId, nextToken, limit: DEFAULT_LIMIT },
              });
            }
          }}
        />
      )}
    </>
  );
};

export default LocationEmployees;
